import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  passwordResetConfirm,
  passwordResetRequest,
  passwordResetVerifyPin,
  showApiError,
} from '~/services';
import { loginUser } from '~/store/auth/login/thunks';

import {
  clearRecovery,
  recoveryFailure,
  recoveryRequest,
  recoverySetEmail,
  recoverySetToken,
  recoverySuccess,
} from './slices';

export const requestPasswordReset = createAsyncThunk(
  'recovery/request',
  async (email: string, { dispatch }): Promise<boolean> => {
    dispatch(recoveryRequest());
    try {
      await passwordResetRequest(email);
      dispatch(recoverySetEmail(email));
      dispatch(recoverySuccess());
      return true;
    } catch (error) {
      dispatch(recoveryFailure());
      return showApiError(error);
    }
  },
);

export const verifyPasswordResetPin = createAsyncThunk(
  'recovery/verify-pin',
  async (
    { email, code }: { email: string; code: string },
    { dispatch },
  ): Promise<boolean> => {
    dispatch(recoveryRequest());
    try {
      const { data } = await passwordResetVerifyPin({ email, code });
      if (!data?.resetToken) {
        dispatch(recoveryFailure());
        return showApiError(new Error('Resposta inválida do servidor'));
      }
      dispatch(recoverySetToken(data.resetToken));
      dispatch(recoverySuccess());
      return true;
    } catch (error) {
      dispatch(recoveryFailure());
      return showApiError(error, { title: 'Código inválido' });
    }
  },
);

export const confirmPasswordReset = createAsyncThunk(
  'recovery/confirm',
  async (
    {
      resetToken,
      email,
      newPassword,
    }: { resetToken: string; email: string; newPassword: string },
    { dispatch },
  ): Promise<boolean> => {
    dispatch(recoveryRequest());
    try {
      await passwordResetConfirm({ resetToken, newPassword });
      dispatch(recoverySuccess());
      const logged = await dispatch(
        loginUser({ username: email, password: newPassword }),
      ).unwrap();
      dispatch(clearRecovery());
      return logged;
    } catch (error) {
      dispatch(recoveryFailure());
      return showApiError(error, { title: 'Não foi possível alterar a senha' });
    }
  },
);
